import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { RegularContainer } from "../../../components/container";
import CardSettings from "../../../features/sales/components/store/CardSettings";
import useTabTitle from "../../../hooks/useTabTitle";
import StoreTabs from "../../tabs/storeTabs";

const StoreCardSettingsPage = () => {
    const { t } = useTranslation();
    const { storeId } = useParams();

    useTabTitle(t("SALES.BranchAdventureSettings") || "Card Settings");

    return (
        <RegularContainer>
            <StoreTabs />
            <span style={{ width: "100%", height: "2rem", display: "block" }}></span>
            <RegularContainer.Heading title={t("SALES.BranchAdventureSettings") || "Card Settings"} />
            <RegularContainer.Content>
                {storeId ? (
                    <CardSettings storeId={storeId} />
                ) : (
                    <div style={{ textAlign: "center", padding: "2rem", color: "#ef4444" }}>
                        {t("SALES.StoreIdNotFound") || "Store ID not found"}
                    </div>
                )}
            </RegularContainer.Content>
        </RegularContainer>
    );
};

export default StoreCardSettingsPage;
